import { useCallback } from "react";
import { useSelector } from "react-redux";

export type WithAuth = (action?: () => void) => () => void;

export type UseWithAuthParams = {
  openAuthModel?: () => void;
};

export function useWithAuth({ openAuthModel = () => {} }: UseWithAuthParams) {
  const userToken = useSelector((state: any) => state.auth.accessToken);

  const withAuth = useCallback<WithAuth>(
    (action = () => {}) => {
      return () => {
        if (!userToken) {
          openAuthModel();
          return;
        }

        action();
      };
    },
    [userToken, openAuthModel],
  );

  return { withAuth };
}
